import _ from "lodash";

export const isPositiveInt = (inputToValidate) => {
  /**
   * @returns {boolean}
   */
  if (!inputToValidate) {
    return false;
  }
  if (!_.isInteger(_.toNumber(inputToValidate)) || inputToValidate < 0) {
    return false;
  }
  return true;
};
